function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { TRACING_DEFAULTS, addTracingExtensions, startIdleTransaction, getActiveTransaction, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, getClient, getCurrentScope } from '@sentry/core';
import { logger, propagationContextFromHeaders, getDomElement } from '@sentry/utils';
import { DEBUG_BUILD } from '../common/debug-build.js';
import { registerBackgroundTabDetection } from './backgroundtab.js';
import { addPerformanceInstrumentationHandler } from './instrument.js';
import { startTrackingWebVitals, startTrackingINP, startTrackingLongTasks, startTrackingInteractions, addPerformanceEntries } from './metrics/index.js';
import { defaultRequestInstrumentationOptions, instrumentOutgoingRequests } from './request.js';
import { instrumentRoutingWithDefaults } from './router.js';
import { WINDOW } from './types.js';
var BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';
/** Options for Browser Tracing integration */

var DEFAULT_BROWSER_TRACING_OPTIONS = _objectSpread(_objectSpread({}, TRACING_DEFAULTS), {}, {
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  enableLongTask: true,
  enableInp: false,
  _experiments: {}
}, defaultRequestInstrumentationOptions);
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */


var MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */

var BrowserTracing = /*#__PURE__*/function () {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */

  /**
   * @inheritDoc
   */
  function BrowserTracing(_options) {
    _classCallCheck(this, BrowserTracing);

    this.name = BROWSER_TRACING_INTEGRATION_ID;
    this._hasSetTracePropagationTargets = false;
    addTracingExtensions();

    if (DEBUG_BUILD) {
      this._hasSetTracePropagationTargets = !!(_options && ( // eslint-disable-next-line deprecation/deprecation
      _options.tracePropagationTargets || _options.tracingOrigins));
    }

    this.options = _objectSpread(_objectSpread({}, DEFAULT_BROWSER_TRACING_OPTIONS), _options); // Special case: enableLongTask can be set in _experiments
    // TODO (v8): Remove this in v8

    if (this.options._experiments.enableLongTask !== undefined) {
      this.options.enableLongTask = this.options._experiments.enableLongTask;
    } // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation


    if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
      // eslint-disable-next-line deprecation/deprecation
      this.options.tracePropagationTargets = _options.tracingOrigins;
    }

    this._collectWebVitals = startTrackingWebVitals();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */

    this._interactionIdtoRouteNameMapping = {};

    if (this.options.enableInp) {
      startTrackingINP(this._interactionIdtoRouteNameMapping);
    }

    if (this.options.enableLongTask) {
      startTrackingLongTasks();
    }

    if (this.options._experiments.enableInteractions) {
      startTrackingInteractions();
    }

    this._latestRoute = {
      name: undefined,
      context: undefined
    };
  }
  /**
   * @inheritDoc
   */


  _createClass(BrowserTracing, [{
    key: "setupOnce",
    value: function setupOnce(_, getCurrentHub) {
      var _this = this;

      this._getCurrentHub = getCurrentHub;
      var hub = getCurrentHub(); // eslint-disable-next-line deprecation/deprecation

      var client = hub.getClient();
      var clientOptions = client && client.getOptions();
      var _this$options = this.options,
          instrumentRouting = _this$options.routingInstrumentation,
          startTransactionOnLocationChange = _this$options.startTransactionOnLocationChange,
          startTransactionOnPageLoad = _this$options.startTransactionOnPageLoad,
          markBackgroundTransactions = _this$options.markBackgroundTransactions,
          traceFetch = _this$options.traceFetch,
          traceXHR = _this$options.traceXHR,
          shouldCreateSpanForRequest = _this$options.shouldCreateSpanForRequest,
          enableHTTPTimings = _this$options.enableHTTPTimings,
          _experiments = _this$options._experiments;
      var clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets; // There are three ways to configure tracePropagationTargets:
      // 1. via top level client option `tracePropagationTargets`
      // 2. via BrowserTracing option `tracePropagationTargets`
      // 3. via BrowserTracing option `tracingOrigins` (deprecated)
      //
      // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
      // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
      // This is done as it minimizes bundle size (we don't have to have undefined checks).
      //
      // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
      // eslint-disable-next-line deprecation/deprecation

      var tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;

      if (DEBUG_BUILD && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) {
        logger.warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
      }

      instrumentRouting(function (context) {
        var transaction = _this._createRouteTransaction(context);

        _this.options._experiments.onStartRouteTransaction && _this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
        return transaction;
      }, startTransactionOnPageLoad, startTransactionOnLocationChange);

      if (markBackgroundTransactions) {
        registerBackgroundTabDetection();
      }

      if (_experiments.enableInteractions) {
        this._registerInteractionListener();
      }

      if (this.options.enableInp) {
        this._registerInpInteractionListener();
      }

      instrumentOutgoingRequests({
        traceFetch: traceFetch,
        traceXHR: traceXHR,
        tracePropagationTargets: tracePropagationTargets,
        shouldCreateSpanForRequest: shouldCreateSpanForRequest,
        enableHTTPTimings: enableHTTPTimings
      });
    }
    /** Create routing idle transaction. */

  }, {
    key: "_createRouteTransaction",
    value: function _createRouteTransaction(context) {
      var _this2 = this;

      if (!this._getCurrentHub) {
        DEBUG_BUILD && logger.warn("[Tracing] Did not create ".concat(context.op, " transaction because _getCurrentHub is invalid."));
        return undefined;
      }

      var hub = this._getCurrentHub();

      var _this$options2 = this.options,
          beforeNavigate = _this$options2.beforeNavigate,
          idleTimeout = _this$options2.idleTimeout,
          finalTimeout = _this$options2.finalTimeout,
          heartbeatInterval = _this$options2.heartbeatInterval;
      var isPageloadTransaction = context.op === 'pageload';
      var expandedContext;

      if (isPageloadTransaction) {
        var sentryTrace = isPageloadTransaction ? getMetaContent('sentry-trace') : '';
        var baggage = isPageloadTransaction ? getMetaContent('baggage') : undefined;

        var _propagationContextFr = propagationContextFromHeaders(sentryTrace, baggage),
            traceId = _propagationContextFr.traceId,
            dsc = _propagationContextFr.dsc,
            parentSpanId = _propagationContextFr.parentSpanId,
            sampled = _propagationContextFr.sampled;

        expandedContext = _objectSpread(_objectSpread({
          traceId: traceId,
          parentSpanId: parentSpanId,
          parentSampled: sampled
        }, context), {}, {
          metadata: _objectSpread(_objectSpread({}, context.metadata), {}, {
            dynamicSamplingContext: dsc
          }),
          trimEnd: true
        });
      } else {
        expandedContext = _objectSpread({
          trimEnd: true
        }, context);
      }

      var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext; // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
      // from being sent to Sentry).

      var finalContext = modifiedContext === undefined ? _objectSpread(_objectSpread({}, expandedContext), {}, {
        sampled: false
      }) : modifiedContext; // If `beforeNavigate` set a custom name, record that fact
      // eslint-disable-next-line deprecation/deprecation

      finalContext.metadata = finalContext.name !== expandedContext.name ? // eslint-disable-next-line deprecation/deprecation
      _objectSpread(_objectSpread({}, finalContext.metadata), {}, {
        source: 'custom'
      }) : // eslint-disable-next-line deprecation/deprecation
      finalContext.metadata;
      this._latestRoute.name = finalContext.name;
      this._latestRoute.context = finalContext; // eslint-disable-next-line deprecation/deprecation

      if (finalContext.sampled === false) {
        DEBUG_BUILD && logger.log("[Tracing] Will not send ".concat(finalContext.op, " transaction because of beforeNavigate."));
      }

      DEBUG_BUILD && logger.log("[Tracing] Starting ".concat(finalContext.op, " transaction on scope"));
      var location = WINDOW.location;
      var idleTransaction = startIdleTransaction(hub, finalContext, idleTimeout, finalTimeout, true, {
        location: location
      }, // for use in the tracesSampler
      heartbeatInterval, isPageloadTransaction // should wait for finish signal if it's a pageload transaction
      );

      if (isPageloadTransaction) {
        WINDOW.document.addEventListener('readystatechange', function () {
          if (['interactive', 'complete'].includes(WINDOW.document.readyState)) {
            idleTransaction.sendAutoFinishSignal();
          }
        });

        if (['interactive', 'complete'].includes(WINDOW.document.readyState)) {
          idleTransaction.sendAutoFinishSignal();
        }
      }

      idleTransaction.registerBeforeFinishCallback(function (transaction) {
        _this2._collectWebVitals();

        addPerformanceEntries(transaction);
      });
      return idleTransaction;
    }
    /** Start listener for interaction transactions */

  }, {
    key: "_registerInteractionListener",
    value: function _registerInteractionListener() {
      var _this3 = this;

      var inflightInteractionTransaction;

      var registerInteractionTransaction = function registerInteractionTransaction() {
        var _this3$options = _this3.options,
            idleTimeout = _this3$options.idleTimeout,
            finalTimeout = _this3$options.finalTimeout,
            heartbeatInterval = _this3$options.heartbeatInterval;
        var op = 'ui.action.click'; // eslint-disable-next-line deprecation/deprecation

        var currentTransaction = getActiveTransaction();

        if (currentTransaction && currentTransaction.op && ['navigation', 'pageload'].includes(currentTransaction.op)) {
          DEBUG_BUILD && logger.warn("[Tracing] Did not create ".concat(op, " transaction because a pageload or navigation transaction is in progress."));
          return undefined;
        }

        if (inflightInteractionTransaction) {
          inflightInteractionTransaction.setFinishReason('interactionInterrupted');
          inflightInteractionTransaction.end();
          inflightInteractionTransaction = undefined;
        }

        if (!_this3._getCurrentHub) {
          DEBUG_BUILD && logger.warn("[Tracing] Did not create ".concat(op, " transaction because _getCurrentHub is invalid."));
          return undefined;
        }

        if (!_this3._latestRoute.name) {
          DEBUG_BUILD && logger.warn("[Tracing] Did not create ".concat(op, " transaction because _latestRouteName is missing."));
          return undefined;
        }

        var hub = _this3._getCurrentHub();

        var location = WINDOW.location;
        var context = {
          name: _this3._latestRoute.name,
          op: op,
          trimEnd: true,
          data: _defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, _this3._latestRoute.context ? getSource(_this3._latestRoute.context) : 'url')
        };
        inflightInteractionTransaction = startIdleTransaction(hub, context, idleTimeout, finalTimeout, true, {
          location: location
        }, // for use in the tracesSampler
        heartbeatInterval);
      };

      ['click'].forEach(function (type) {
        addEventListener(type, registerInteractionTransaction, {
          once: false,
          capture: true
        });
      });
    }
    /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */

  }, {
    key: "_registerInpInteractionListener",
    value: function _registerInpInteractionListener() {
      var _this4 = this;

      addPerformanceInstrumentationHandler('event', function (_ref) {
        var entries = _ref.entries;
        var client = getClient(); // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span

        var replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName('Replay') : undefined;
        var replayId = replay !== undefined ? replay.getReplayId() : undefined; // eslint-disable-next-line deprecation/deprecation

        var activeTransaction = getActiveTransaction();
        var currentScope = getCurrentScope();
        var user = currentScope !== undefined ? currentScope.getUser() : undefined;

        var _iterator = _createForOfIteratorHelper(entries),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;

            if (isPerformanceEventTiming(entry)) {
              var duration = entry.duration;
              var keys = Object.keys(_this4._interactionIdtoRouteNameMapping);
              var minInteractionId = keys.length > 0 ? keys.reduce(function (a, b) {
                return _this4._interactionIdtoRouteNameMapping[a].duration < _this4._interactionIdtoRouteNameMapping[b].duration ? a : b;
              }) : undefined;

              if (minInteractionId === undefined || duration > _this4._interactionIdtoRouteNameMapping[minInteractionId].duration) {
                var interactionId = entry.interactionId;
                var routeName = _this4._latestRoute.name;
                var parentContext = _this4._latestRoute.context;

                if (interactionId && routeName && parentContext) {
                  if (minInteractionId && Object.keys(_this4._interactionIdtoRouteNameMapping).length >= MAX_INTERACTIONS) {
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete _this4._interactionIdtoRouteNameMapping[minInteractionId];
                  }

                  _this4._interactionIdtoRouteNameMapping[interactionId] = {
                    routeName: routeName,
                    duration: duration,
                    parentContext: parentContext,
                    user: user,
                    activeTransaction: activeTransaction,
                    replayId: replayId
                  };
                }
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }]);

  return BrowserTracing;
}();
/** Returns the value of a meta tag */


function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  var metaTag = getDomElement("meta[name=".concat(metaName, "]")); // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access

  return metaTag ? metaTag.getAttribute('content') : undefined;
}

function getSource(context) {
  var sourceFromAttributes = context.attributes && context.attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]; // eslint-disable-next-line deprecation/deprecation

  var sourceFromData = context.data && context.data[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]; // eslint-disable-next-line deprecation/deprecation

  var sourceFromMetadata = context.metadata && context.metadata.source;
  return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

function isPerformanceEventTiming(entry) {
  return 'duration' in entry;
}

export { BROWSER_TRACING_INTEGRATION_ID, BrowserTracing, getMetaContent };